import { render, staticRenderFns } from "./PhoneTextComponentGlobal.vue?vue&type=template&id=461c5c22&scoped=true&"
import script from "./PhoneTextComponentGlobal.vue?vue&type=script&lang=js&"
export * from "./PhoneTextComponentGlobal.vue?vue&type=script&lang=js&"
import style0 from "./PhoneTextComponentGlobal.vue?vue&type=style&index=0&id=461c5c22&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "461c5c22",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
